import React from 'react'
import { useStore } from 'src/state'
import Page from 'src/components/page'
import Container from 'src/components/container'
import HeroSection from 'src/components/hero-section'
import Section from 'src/components/section'
import Link from 'src/components/link'

const CareersPage = () => {
  const {
    careersPage: { hero, listings },
  } = useStore()

  return (
    <Page className="page-careers">
      <HeroSection {...hero} />
      <Section>
        <Container>
          <div className="listings">
            {listings.map((listing) => (
              <div key={listing.id} className="listing">
                <h3 className="title size-medium">{listing.title}</h3>
                <div className="location-status">
                  <div className="location">{listing.location}</div>
                  <div className="pipe">|</div>
                  <div className="status">{listing.status}</div>
                </div>
                <p className="description">{listing.description}</p>
                <Link className="cta" to={listing.buttonUrl} newTab>
                  {listing.buttonText}
                </Link>
              </div>
            ))}
          </div>
        </Container>
      </Section>
    </Page>
  )
}

export default CareersPage
